import React, {Component} from 'react';

class VersionApp extends Component {
    render(){
        return(
            <center><h4>version {process.env.REACT_APP_VERSION}</h4></center>
        );
    }
}

export default VersionApp;